import { FC, Fragment, useEffect } from "react";

export type CheckBoxProps = Omit<JSX.IntrinsicElements["input"], "value"> & {
  value: boolean;
};

export const CheckBox: FC<CheckBoxProps> = ({
  onChange,
  value,
  name,
  disabled,
  ...props
}) => {
  useEffect(() => {
    if (disabled && typeof onChange == "function") {
      onChange({
        target: {
          name: name,
          value: false,
        },
      } as any);
    }
  }, [disabled]);

  return (
    <Fragment>
      <input
        {...props}
        disabled={disabled}
        name={name}
        type="checkbox"
        className="h-4 w-4 rounded border-gray-300 text-primary focus:border-primary"
        onChange={(event) =>
          typeof onChange == "function" &&
          onChange({
            target: {
              name: name,
              value: event.target.checked,
            },
          } as any)
        }
        checked={value}
      />
    </Fragment>
  );
};
